export const dialogs = {
	NON_UNIQUE_SOLVER: 'NON_UNIQUE_SOLVER',
};

export const radioOptionsIds = {
	superior: 'superior',
	subordinate: 'subordinate',
	users: 'users',
	agency: 'agency',
	marketPlace: 'marketPlace',
};

export const radioOptions = [
	{ id: 'superior', description: 'resolverSettings:superiorRadio' },
	{ id: 'subordinate', description: 'resolverSettings:subordinateRadio' },
	{ id: 'users', description: 'resolverSettings:usersRadio' },
	{ id: 'agency', description: 'resolverSettings:agencyRadio' },
	{ id: 'marketPlace', description: 'resolverSettings:marketPlaceRadio' },
];

export const searchUserTypes = {
	USER_LIST_SEARCH: 'USER_LIST_SEARCH',
	MARKET_PLACE_AGENCIES_SEARCH: 'MARKET_PLACE_AGENCIES_SEARCH',
};
